import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CollapseChip } from "../CollapseChip.js";
import { transientOptions } from "../styles.js";
export const TypographyWithMaxNumberOfLines = styled(Typography, transientOptions)(({ theme, $maxLines, variant }) => $maxLines > 1
    ? {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitLineClamp: $maxLines,
        WebkitBoxOrient: "vertical",
        maxHeight: `calc(${theme.typography[variant].fontSize} * ${theme.typography[variant].lineHeight} * ${$maxLines})`,
    }
    : $maxLines === 1
        ? {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxHeight: `calc(${theme.typography[variant].fontSize} * ${theme.typography[variant].lineHeight})`,
        }
        : {});
export const TypographyWithIcon = ({ icon, count, fullWidth, children, ...props }) => {
    return (_jsxs(Typography, { sx: {
            display: "inline-flex",
            alignItems: "center",
            [".MuiSvgIcon-root, .MuiIcon-root"]: {
                marginRight: "4px",
                fontSize: "1.375rem",
            },
            ...(fullWidth ? { width: "100%" } : undefined),
        }, ...props, children: [icon, children, count !== undefined && (_jsx(Box, { display: "flex", alignItems: "center", ml: 1, component: "span", height: "1em", children: _jsx(CollapseChip, { label: count }) }))] }));
};
//# sourceMappingURL=Typography.js.map